<template>
  <div
    class="row flex-nowrap justify-content-around mx-auto text-black border-bottom border-danger text-center mb-5"
  >
    <h1 class="text-uppercase mt-2" id="header">
      Maak uw keuze uit ons productlijst: {{ this.$options.collectionLabel }}
      {{ this.$options.assortimentLabel }}
    </h1>
  </div>

  <div class="container-fluid mx-auto row">
    <Filter :products="buildPage" v-on:filterd="getFilterdProducts" />
    <div class="col-12 col-lg-9 ms-lg-3 flex-grow-1">
      <div
        class="row productlist justify-content-xl-start justify-content-center"
      >
        <template v-for="(tile, key, index) in Tiles" :key="tile.index">
          <SelectionTile
            :tile="tile"
            v-if="index >= getLowerBound && index < getUpperBound"
          />
        </template>
      </div>
      <div class="d-flex flex-row prodNavBtn" v-if="filterdProducts.length > 9">
        <button @click="pageDown" class="col-3" v-if="showPageDownBtn">
          <i class="fa-thin fa-less-than fa-2xl"></i>
        </button>
        <p class="col-3">{{ this.page }} / {{ this.getPages }}</p>
        <button @click="pageUp" class="col-3" v-if="showPageUpBtn">
          <i class="fa-thin fa-greater-than fa-2xl"></i>
        </button>
        <select
          v-model="selected"
          @change="setPageLength(selected)"
          class="col-3"
        >
          <option value="10">10</option>
          <option value="25" selected>25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import Filter from "@/components/Filter.vue";
import SelectionTile from "@/components/SelectionTile.vue";

export default {
  name: "Products",
  assortimentLabel: "",
  collectionLabel: "",
  components: {
    Filter,
    // ProductList,
    SelectionTile,
  },
  data() {
    return {
      classes: {
        link: "card col-5 col-md-2 col-lg-2 bg-light p-0 border border-1 mb-2 productlist-tiles",
        img: "productlist-img border-bottom border-1",
        text: "card-body text-dark fontSizeCard text-uppercase",
        icon: "bi bi-arrow-right-circle",
      },
      Tiles: {},
      assortiment: "",
      products: [],
      filterdProducts: [],
      collectionProperties: "",
      selected: 25,
      productsPerPage: 25,
      page: 1,
      //end return
    };
    // end data
  },
  created() {
    this.$store.commit("storeLocUpdate", true);
  },
  mounted() {},
  beforeUnmount() {
    // delete filter settings
    this.$store.commit("storeFILTER", { key: "color", value: "" });
    this.$store.commit("storeFILTER", { key: "rol", value: "" });
    this.$store.commit("storeFILTER", { key: "rug", value: "" });
    this.$store.commit("storeFILTER", { key: "methode", value: "" });
    this.pageExit = true;
  },
  unmounted() {
    this.pageExit = true;
  },
  beforeUpdate() {},
  updated() {
    this.$store.commit("storeLocUpdate", true);
  },
  computed: {
    getLowerBound() {
      return this.productsPerPage * (this.page - 1);
    },
    getUpperBound() {
      return this.productsPerPage * this.page;
    },
    showPageDownBtn() {
      if (this.page === 1) {
        return false;
      } else {
        return true;
      }
    },
    showPageUpBtn() {
      if (this.selected * this.page < this.filterdProducts.length) {
        return true;
      } else {
        return false;
      }
    },
    getPages() {
      return (
        Math.floor(
          (Object.keys(this.Tiles).length - 1) / this.productsPerPage
        ) + 1
      );
    },
    buildPage() {
      return this.loadPage();
    },
  },
  methods: {
    getFilterdProducts(value) {
      this.page = 1;
      this.filterdProducts = value;
      this.Tiles = this.buildTiles(value);
    },
    loadPage() {
      // get selection
      const selection = this.$Functions.getSelection(this.$route.name);

      // get assortiment
      this.assortiment = this.$Functions.getAssortmentProp(
        selection.assortmentCode,
        this.$store.getters.getLang
      );

      if (
        selection.collectionCode === "" ||
        selection.collectionCode === undefined
      ) {
        selection.collectionCode = selection.assortmentCode;
      }

      // if All ISNT selected
      if (selection.collectionCode !== "ALL") {
        this.collectionProperties = this.$Functions.getCollectionProp(
          selection.assortmentCode,
          selection.collectionCode,
          this.$store.getters.getLang
        );
        this.$options.collectionLabel = this.collectionProperties.label;
        if (
          this.collectionProperties.label
            .replaceAll("-", "")
            .replaceAll(" ", "")
            .toLowerCase() !==
            this.assortiment.label
              .replaceAll("-", "")
              .replaceAll(" ", "")
              .toLowerCase() &&
          this.collectionProperties.label.match("All") === null
        ) {
          this.$options.assortimentLabel = this.assortiment.label;
        }
      }

      return this.getProductData();
    },
    getProductData() {
      let products = [];
      const selection = this.$Functions.getSelection(this.$route.name);

      if (
        selection.collectionCode === "" ||
        selection.collectionCode === undefined
      ) {
        selection.collectionCode = selection.assortmentCode;
      }

      // get selected product
      if (selection.collectionCode !== "ALL") {
        products = this.$Functions.getCollectionData(
          selection.assortmentCode,
          selection.collectionCode,
          this.$store.getters.getLang
        );
      }
      // get all products from collection
      else {
        const collectionsData = this.$Functions.getData(
          `${selection.assortmentCode.toLowerCase()}/collections`,
          this.$store.getters.getLang
        );

        for (let index in collectionsData) {
          products = [
            ...products,
            ...this.$Functions.getCollectionData(
              selection.assortmentCode,
              collectionsData[index].code,
              this.$store.getters.getLang
            ),
          ];
        }
      }

      return products;
      // end getProductData
    },
    buildTiles(products) {
      let Tiles = {};

      for (const iProduct in products) {
        const product = products[iProduct];

        // build label
        let code = "";
        if (product.code !== undefined && product.code !== "") {
          if (typeof product.code == "number") {
            if (product.code < 1000 && product.code > 100) {
              code = "0" + product.code;
            } else if (product.code < 100 && product.code > 10) {
              code = "00" + product.code;
            } else if (product.code < 10) {
              code = "000" + product.code;
            } else {
              code = product.code;
            }
          } else {
            code = product.code;
          }
          code = code + " - ";
        }

        let color = "";
        if (product.kleur !== undefined && product.kleur !== "") {
          if (product.kleur !== product.naam) {
            color = " - " + product.kleur;
          }
        }

        const label = code + product.naam + color;

        const lang = this.$store.getters.getLang.slice(0, 2);

        // build tiles
        const tilesKey = product.productCode;

        if (!Object.prototype.hasOwnProperty.call(Tiles, tilesKey)) {
          // build tiles data
          Tiles[tilesKey] = {
            properties: {
              link: `${lang}-${product.productCode}`,
              imgAlt: product.code + " " + product.naam + " " + product.kleur,
              imgSrc: product.afbeelding,
              text: label,
            },
            selectors: {
              class: {
                link: this.classes.link,
                img: this.classes.img,
                text: this.classes.text,
                icon: this.classes.icon,
              },
              id: {
                link: "",
                img: "",
                text: "",
                icon: "",
              },
            },
          };
          // end tiles
        }
        // end product loop
      }
      return Tiles;
      // end buildTiles
    },
    pageUp() {
      if (this.page < this.getPages) {
        this.page++;
      }
    },
    pageDown() {
      if (this.page > 1) {
        this.page--;
      }
    },
    setPageLength(pageLength) {
      this.page = 1;
      this.productsPerPage = pageLength;
    },
    // end methods
  },
  watch: {},
};
</script>

<style lang=css>
 @import "../styles/product.css";
</style>

<style scoped>
.productlist {
  width: 100%;
}
.productlist-tiles {
  width: 22%;
  margin: 0% 2% 0% 0%;
  border: none !important;
  background-color: #f1f2f9 !important;
}

@media screen and (max-width: 1107px) {
  .productlist-tiles {
    width: 28%;
    margin: 0% 1% 0% 2%;
    justify-content: start;
  }
}
@media screen and (max-width: 768px) {
  .productlist-tiles {
    width: 28%;
    margin: 0% 1% 0% 2%;
    justify-content: start;
  }
}
@media screen and (max-width: 425px) {
  .productlist-tiles {
    width: 50%;
    margin: 0% 0% 0% 4%;
    justify-content: center;
  }
}
</style>
